import { ThemeWrapper } from "@verity/components";
import TestResultsWrapper from "../results/components/TestResultsWrapper";

export function AssessmentReport() {
	return (
		<ThemeWrapper scoped={false}>
			<TestResultsWrapper />
		</ThemeWrapper>
	);
}
